<template>
  <header class="header">
    <div class="header-content">
      <div class="logo">
        <router-link to="/" class="logo-link">
          <img src="../assets/logo.png" alt="Quick Task" />
          <span class="logo-text">团队任务</span>
        </router-link>
      </div>
      
      <button class="menu-toggle" @click="store.toggleMenu" v-if="isMobile">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav class="nav" :class="{ 'nav-mobile': isMobile, 'nav-visible': menuVisible }">
        <router-link to="/" @click="handleNavClick">首页</router-link>
        <router-link to="/download" @click="handleNavClick">下载</router-link>
        <router-link to="/about" @click="handleNavClick">关于我们</router-link>
        <router-link to="/contact" @click="handleNavClick">联系我们</router-link>
      </nav>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useAppStore } from '../store'
import { storeToRefs } from 'pinia'

const store = useAppStore()
const { isMobile, menuVisible } = storeToRefs(store)

const handleNavClick = () => {
  if (isMobile.value) {
    store.toggleMenu()
  }
}
</script>

<script lang="ts">
export default {
  name: 'Header'
}
</script>

<style lang="scss" scoped>
.header {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(5px);
  
  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    .logo-link {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      text-decoration: none;
    }

    img {
      height: 40px;
      width: 40px;
      object-fit: contain;
      transition: transform 0.3s;
      border-radius: 8px;
    }

    .logo-text {
      font-size: 1.5rem;
      font-weight: 600;
      color: var(--text-color);
    }

    &:hover {
      img {
        transform: scale(1.05);
      }
    }
  }

  .nav {
    display: flex;
    gap: 2rem;

    a {
      color: var(--text-color);
      text-decoration: none;
      font-weight: 500;
      padding: 0.5rem 1rem;
      border-radius: var(--border-radius);
      transition: all 0.3s;
      
      &:hover {
        color: var(--primary-color);
        background: rgba(24, 144, 255, 0.1);
      }

      &.router-link-active {
        color: var(--primary-color);
        background: rgba(24, 144, 255, 0.1);
      }
    }
  }

  .menu-toggle {
    display: none;
    flex-direction: column;
    gap: 6px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: var(--border-radius);
    transition: background-color 0.3s;
    z-index: 100;

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    span {
      display: block;
      width: 24px;
      height: 2px;
      background: var(--text-color);
      transition: 0.3s;
    }
  }

  @media (max-width: 768px) {
    .menu-toggle {
      display: flex;
    }

    .nav {
      &.nav-mobile {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.98);
        padding: 1rem;
        flex-direction: column;
        text-align: center;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
        z-index: 99;

        a {
          padding: 1rem;
          display: block;
          width: 100%;
          border-radius: 0;

          &:hover {
            background: rgba(24, 144, 255, 0.1);
          }
        }

        &.nav-visible {
          display: flex;
          animation: slideDown 0.3s ease-out;
        }
      }
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style> 